import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING } from "const"
import { StateType } from "client/utils"
import {
    StoreType,
    CcReviewComplianceProps,

    LoadProjectByIdOnly,
    LoadCcApprovalLevels,
    LoadCcResponses,
    LoadCcLibraryItemById,
    LoadCcReviewComplianceHistory,

    setCcApprovalLevelList,
    setCcResponseList,
    setCcModuleResponseList,
    setCcReviewComplianceItemDetails,
    setCcReviewComplianceItemHistory,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    Loader,
} from "client/components"

import NotFound from "client/parts/notFound"
import Details from "./details"
import History from "./history"

interface ReviewComplianceAnswerProps extends CcReviewComplianceProps {
    projectId: number
}

const ReviewComplianceAnswer = ({
    projectId,
    setId,
    revisionId,
    complianceItemId,
}: ReviewComplianceAnswerProps) => {
    const item = useSelector((state: StoreType) => state.ccReviewCompliance.itemDetails)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [loadState, setLoadState] = useState<StateType>(IDLE)

    useEffect(() => {
        setLoadState(PENDING)
        LoadProjectByIdOnly(projectId).then((project) => (
            Promise.all([
                // review approval levels
                LoadCcApprovalLevels(project.accountId, project.id, 2)
                .then((res) => {
                    dispatch(setCcApprovalLevelList(res.levelList))
                }),
                // formal approval levels
                LoadCcApprovalLevels(project.accountId, project.id, 0)
                .then((res) => {
                    dispatch(setCcApprovalLevelList(res.levelList))
                }),
                // review (compliance) responses
                LoadCcResponses(project.accountId, project.id, 2)
                .then((res) => {
                    dispatch(setCcResponseList(res.responseList))
                    dispatch(setCcModuleResponseList({ 2: res.responseIds }))
                }),
                // responsible responses
                LoadCcResponses(project.accountId, project.id, 0)
                .then((res) => {
                    dispatch(setCcResponseList(res.responseList))
                    dispatch(setCcModuleResponseList({ 0: res.responseIds }))
                }),
                LoadCcLibraryItemById(complianceItemId, setId).then((res) => {
                    dispatch(setCcReviewComplianceItemDetails(res))
                }),
                LoadCcReviewComplianceHistory(complianceItemId, revisionId).then((res) => {
                    dispatch(setCcReviewComplianceItemHistory(res))
                }),
            ])
        )).then(() => {
            setLoadState(IDLE)
        })
    }, [])

    if (!item) return <NotFound />
    return (
        <Container>
            <PageHeader>
                <PageTitle>{lang.editAnswer}</PageTitle>
            </PageHeader>
            <PageContent>
                {
                    loadState === PENDING
                    && <Loader />
                }

                <Details />
                <History />
            </PageContent>
        </Container>
    )
}
export default ReviewComplianceAnswer
